// extracted by mini-css-extract-plugin
export default {"root":"style-module__root___yki37","meta_root":"style-module__meta_root___awNEo","root__loader":"style-module__root__loader___hwjxe"};
    if(module.hot) {
      // 1729151131929
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  